//---------------------------------------------------------
// Soft field helpers (pure, unit-tested).
//---------------------------------------------------------

export type SoftMessageTone = 'helper' | 'warning' | 'error';

/**
 * One message line under a control. Error beats warning beats helper, and a
 * warning or error replaces the helper instead of stacking under it.
 */
export function softFieldMessage(args: {
	helper?: string | null;
	warning?: string | null;
	error?: string | null;
}): {tone: SoftMessageTone; text: string} | null {
	if (args.error) return {tone: 'error', text: args.error};
	if (args.warning) return {tone: 'warning', text: args.warning};
	if (args.helper) return {tone: 'helper', text: args.helper};
	return null;
}

/** Empty-select placeholders, one per pick list. */
export const SOFT_SELECT_PLACEHOLDER = {
	account: 'Choose an account',
	sshKey: 'Choose an SSH key',
	template: 'Choose a template',
} as const;

/** True when a select has no value yet and should show its placeholder. */
export function isEmptySelectValue(value: unknown): boolean {
	return value === undefined || value === null || value === '';
}

const MONO_TOKEN = /(\b\d{1,3}(?:\.\d{1,3}){3}(?:\/\d{1,2})?\b)/;

/**
 * Split copy into runs so addresses/CIDRs render in the mono face at the same
 * size as the surrounding text. Odd indexes are mono.
 */
export function splitMonoRuns(text: string): {text: string; mono: boolean}[] {
	return text
		.split(MONO_TOKEN)
		.map((part, i) => ({text: part, mono: i % 2 === 1}))
		.filter(run => run.text.length > 0);
}
